import {z} from 'zod';
import {baseCardSchema} from './baseSchemas';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {LocationTargetingMethodValue} from 'common/src/modules/locationFeed/locationFeed.types';

const DefaultMaxDistKm = 10;

const locationStartegyValueToName = {
  [LocationTargetingMethodValue.NearestLocation]: 'Nearest Location',
  [LocationTargetingMethodValue.ByZipCode]: 'By Zip Code',
  [LocationTargetingMethodValue.ByZipCodeFromDsp]: 'By Zip Code From DSP',
  [LocationTargetingMethodValue.ByDMA]: 'By DMA',
  [LocationTargetingMethodValue.SpecificStore]: 'Specific Store',
};

const nodeOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
  nodeId: z.number().describe('The node ID of the output'),
  id: z.number().describe('The ID of the output'),
});

export const locationCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.STORE),
  locationTargetingMethod: z
    .nativeEnum(LocationTargetingMethodValue)
    .describe(
      `The location targeting method, should be one of the following: ${Object.values(locationStartegyValueToName).join(', ')}`,
    ),
  locationFeedId: z.number().describe('The location feed ID'),
  locationSetId: z
    .number()
    .nullable()
    .describe('The location set ID, if store targeting method requires it'),
  maxDistKm: z
    .number()
    .default(DefaultMaxDistKm)
    .nullable()
    .describe(
      'The max distance from store in km, should be populated if the targeting method is Nearest Location',
    ),
  topLocationIds: z
    .array(z.string())
    .nullable()
    .describe(
      'Specific location ids or names, provided by the user, should be populated if the targeting method is Specific Store',
    ),
  outputs: z.array(nodeOutputSchema).describe('The outputs of the card'),
});

export {DefaultMaxDistKm};
